"use client";

import { getCoinProperties } from "deso-protocol";
import Link from "next/link";
import React, { use, useEffect, useState } from "react";
import { LuExternalLink } from "react-icons/lu";

import { useIsLoggedIn } from "@/components/shared/is-logged-in";
import { SignUp } from "@/components/shared/signup";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { createToastErrorDetails } from "@/components/ui/toast-helpers";
import { toast } from "@/components/ui/use-toast";
import { UserContext } from "@/contexts/user-context";
import { APP_ROUTES, OPENFUND_APP_NAME } from "@/utils/constants";

const TradeOverview = () => {
  const { currentUserPublicKey } = use(UserContext);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tradeCoinExist, setTradeCoinExist] = useState(true);

  const IsLoggedIn = useIsLoggedIn();

  useEffect(() => {
    const getTradeCoinSettings = async () => {
      if (!currentUserPublicKey) {
        setInitialLoading(false);
        setTradeCoinExist(false);
        return;
      }

      try {
        const coinPropertiesResponse = await getCoinProperties(
          {
            BaseCurrencyPublicKey: currentUserPublicKey,
          },
          {
            nodeURI: process.env.NEXT_PUBLIC_AMM_URI,
          },
        );

        setTradeCoinExist(coinPropertiesResponse.AmmConfigs?.length > 0);

        setInitialLoading(false);
      } catch (error) {
        setInitialLoading(false);

        toast({
          variant: "destructive",
          title: "Error",
          description: `An error occurred while fetching your trade coin settings`,
          details: createToastErrorDetails(error),
        });
      }
    };

    getTradeCoinSettings();
  }, [currentUserPublicKey]);

  return (
    <div
      className="
        w-full self-center overflow-x-auto
        md:w-auto
      "
    >
      <div
        className="
          flex w-full flex-col items-center justify-center gap-2
          md:w-auto md:justify-normal
        "
      >
        <div
          className="
            flex flex-row-reverse justify-center gap-x-4
            md:flex-row
          "
        >
          <Link href={`${process.env.NEXT_PUBLIC_OPENFUND_URI}/trade`}>
            <Button
              key="trade-on-openfund"
              className="flex items-center gap-2"
              variant="outline"
              size="sm"
            >
              Trade on {OPENFUND_APP_NAME}
              <LuExternalLink className="text-muted" />
            </Button>
          </Link>
          {IsLoggedIn ? (
            <>
              {initialLoading ? (
                <Skeleton className="h-9 w-32" />
              ) : (
                <Link
                  href={
                    !tradeCoinExist
                      ? APP_ROUTES.tradeLaunch
                      : APP_ROUTES.settingsTradeCoin
                  }
                >
                  <Button key="launch-coin" variant="default" size="sm">
                    {!tradeCoinExist ? "Launch" : "Manage"} Token
                  </Button>
                </Link>
              )}
            </>
          ) : (
            <SignUp showBountyHunterLink={false} showTradeFocusLink={false} />
          )}
        </div>
      </div>
    </div>
  );
};

export default TradeOverview;
